import { buildDashItem } from 'experiences/dashboard/DashboardRoot/lib/types'

export const buildDefaultDashItem = () => buildDashItem(<div />)
